import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from 'react';
import { ButtonBase } from '../ButtonBase/ButtonBase';
import './Modal.scss';

export interface IModal {
    handleClose: () => void;
    show: boolean;
    content: JSX.Element;
    title?: string;
    showCancel?: boolean;
    footer?: ReactNode;
    /** Wider and taller, for a dialog that compares things side by side. */
    wide?: boolean;
}

export const Modal = ({
    handleClose,
    show,
    content,
    title,
    showCancel = true,
    footer,
    wide = false,
}: IModal) => {
    const showModal = `${show ? 'arl-modal--show' : 'arl-modal--hide'}${wide ? ' arl-modal--wide' : ''}`;
    const showOverlay = show
        ? 'arl-modal__overlay--show'
        : 'arl-modal__overlay--hide';

    return (
        <div>
            <div className={showOverlay} onClick={handleClose}></div>
            <div className={'arl-modal ' + showModal}>
                <div className="arl-modal__header d-flex">
                    <div>{title}</div>
                    <div className="ms-auto">
                        <ButtonBase
                            label={
                                <FontAwesomeIcon
                                    icon="circle-xmark"
                                    className="fa-2xl"
                                />
                            }
                            handleClick={handleClose}
                            customClassName="arl-btn__close"
                        />
                    </div>
                </div>
                <div className="arl-modal__body">{content}</div>
                <div className="arl-modal__footer">
                    {footer ? (
                        footer
                    ) : showCancel ? (
                        <ButtonBase
                            label="cancel"
                            handleClick={handleClose}
                            customClassName="btn-primary btn-sm ms-auto"
                        />
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    );
};
